import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-6 fill-current",
  viewBox: "0 0 27 26"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.459.607a1 1 0 0 1 .897.558l3.475 7.04 7.773 1.137a1 1 0 0 1 .553 1.706l-5.624 5.477 1.327 7.737a1 1 0 0 1-1.45 1.055l-6.951-3.656-6.95 3.655a1 1 0 0 1-1.452-1.054l1.327-7.737-5.623-5.477a1 1 0 0 1 .553-1.706l7.773-1.136 3.475-7.041a1 1 0 0 1 .897-.558Zm0 3.26-2.811 5.695a1 1 0 0 1-.752.547l-6.289.919 4.55 4.431a1 1 0 0 1 .287.886l-1.073 6.258 5.622-2.957a1 1 0 0 1 .931 0l5.623 2.957-1.074-6.259a1 1 0 0 1 .288-.885l4.55-4.431-6.289-.92a1 1 0 0 1-.752-.546L13.46 3.867Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }